import { useState } from "react";

// MUI Components
import { Box, Tab, Tabs, Typography } from "@mui/material";

// Components
import { CustomTabContent } from "components/CustomTabContent";

// Styles
import { Theme } from "@mui/material/styles";

type TBehaviouralFilterTab =
    | { label: string; intro: string; component: JSX.Element; tabs?: undefined }
    | { label: string; intro: string; tabs: { label: string; component: JSX.Element }[]; component?: undefined };

type TBehaviouralFilterProps = {
    tabs: TBehaviouralFilterTab[];
};

const BehaviouralFilter = ({ tabs }: TBehaviouralFilterProps) => {
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [innerTabIndex, setInnerTabIndex] = useState<number>(0);

    const handleTabChange = (ev: React.SyntheticEvent, tabId: number) => {
        setTabIndex(tabId);
    };

    const handleInnerTabsChange = (ev: React.SyntheticEvent, tabId: number) => {
        setInnerTabIndex(tabId);
    };

    return (
        <Box
            sx={(theme: Theme) => ({
                width: "100%",
                minHeight: "calc(100vh - 265px)",
                borderRadius: 1,
                padding: theme.spacing(1),
                marginTop: theme.spacing(1),
                backgroundColor: theme.palette.background.blue,
            })}
        >
            <Tabs
                centered
                value={tabIndex}
                onChange={handleTabChange}
                TabIndicatorProps={{
                    sx: {
                        bottom: "8px",
                        height: "2px",
                    },
                }}
            >
                {tabs.map((tab) => (
                    <Tab
                        key={tab.label}
                        disableRipple
                        sx={(theme: Theme) => ({
                            padding: 0,
                            minWidth: "auto",
                            mx: 1,
                            "&.Mui-selected": {
                                color: theme.palette.button.active.from,
                                "& .MuiTypography-root": {
                                    fontWeight: 700,
                                },
                            },
                        })}
                        label={
                            <Typography variant="subtitle2" sx={{ textTransform: "none" }}>
                                {tab.label}
                            </Typography>
                        }
                    />
                ))}
            </Tabs>

            {tabs.map((tab, i) => (
                <CustomTabContent index={i} key={i} value={tabIndex}>
                    {/* <Typography
                        variant="subtitle2"
                        sx={(theme: Theme) => ({
                            color: theme.palette.secondary.main,
                            margin: theme.spacing(1, 0),
                        })}
                    >
                        {tab.intro}
                    </Typography> */}

                    {tab.component && tab.component}

                    {tab.tabs && (
                        <Tabs
                            centered
                            sx={(theme: Theme) => ({
                                ".MuiTab-root": {
                                    textTransform: "none",
                                    "&. Mui-selected": {
                                        color: theme.palette.button.active.from,
                                        fontWeight: "700 !important",
                                    },
                                },
                            })}
                            value={innerTabIndex}
                            onChange={handleInnerTabsChange}
                            TabIndicatorProps={{
                                sx: {
                                    bottom: "8px",
                                    height: "2px",
                                },
                            }}
                        >
                            {tab.tabs.map((innerTab, i) => (
                                <Tab
                                    key={i}
                                    disableRipple
                                    sx={(theme: Theme) => ({
                                        ".MuiTab-root": {
                                            textTransform: "none",
                                            "&. Mui-selected": {
                                                color: theme.palette.button.active.from,
                                                fontWeight: "700 !important",
                                            },
                                        },
                                    })}
                                    label={
                                        <Typography variant="subtitle2" sx={{ textTransform: "none" }}>
                                            {innerTab.label}
                                        </Typography>
                                    }
                                />
                            ))}
                        </Tabs>
                    )}

                    {tab.tabs &&
                        tab.tabs.map((innerTab, i) => (
                            <CustomTabContent key={i} index={i} value={innerTabIndex}>
                                {innerTab.component}
                            </CustomTabContent>
                        ))}
                </CustomTabContent>
            ))}
        </Box>
    );
};

export default BehaviouralFilter;
